"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _childrenUserManage = require("@/api/userCenter/childrenUserManage");
var _childrenButtons = _interopRequireDefault(require("@/views/userCenter/componens/childrenButtons.vue"));
var _billButtons = _interopRequireDefault(require("@/views/userCenter/componens/billButtons.vue"));
var _index = _interopRequireDefault(require("@/components/filterColumn/index.vue"));
var _portRole = _interopRequireDefault(require("@/componentsBuz/Associate/portRole.vue"));
var _childrenPortButtons = _interopRequireDefault(require("@/views/userCenter/componens/childrenPortButtons.vue"));
var _addSubAccount = _interopRequireDefault(require("./componens/addSubAccount"));
var _assignRole = _interopRequireDefault(require("./componens/assignRole"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "childrenUserManage",
  components: {
    addSubAccount: _addSubAccount.default,
    assignRole: _assignRole.default,
    ChildrenPortButtons: _childrenPortButtons.default,
    GlPortRole: _portRole.default,
    billButtons: _billButtons.default,
    ChildrenButtons: _childrenButtons.default,
    Pagination: _Pagination.default,
    filterColumn: _index.default
  },
  data: function data() {
    return {
      yesOrNoList: [{
        displayValueCn: this.$t('yes'),
        codeValue: '1'
      }, {
        displayValueCn: this.$t('no'),
        codeValue: '0'
      }],
      addUserDialog: false,
      listQuery: {
        currentPage: 1,
        pageSize: 5000,
        total: 0
      },
      listQueryChildren: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      tableDataMain: [],
      tableDataChildren: [],
      hotSettings: {
        dragCheck: true,
        height: 'calc(50vh - 195px)',
        width: 'auto',
        stretchH: 'all',
        manualColumnResize: true,
        language: 'zh-CN',
        licenseKey: '8a4e2-659ac-afa83-14d2e-cb603',
        readOnly: true,
        showSelection: false,
        fixedColumnsLeft: 1,
        autoColumnSize: true,
        fragmentSelection: 'cell',
        copyPaste: false
      },
      sysAccountId: '',
      accountNo: '',
      rules: {
        name: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }, {
          min: 3,
          max: 5,
          message: '长度在 3 到 5 个字符',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          message: '请选择活动区域',
          trigger: 'change'
        }],
        date1: [{
          type: 'date',
          required: true,
          message: '请选择日期',
          trigger: 'change'
        }],
        date2: [{
          type: 'date',
          required: true,
          message: '请选择时间',
          trigger: 'change'
        }],
        type: [{
          type: 'array',
          required: true,
          message: '请至少选择一个活动性质',
          trigger: 'change'
        }],
        resource: [{
          required: true,
          message: '请选择活动资源',
          trigger: 'change'
        }],
        desc: [{
          required: true,
          message: '请填写活动形式',
          trigger: 'blur'
        }]
      },
      addPortDialog: false,
      userInfo: this.$store.state.user.userInfo,
      searchForm: {
        accountNo: '',
        accountName: ''
      },
      accountTypeList: []
    };
  },
  created: function created() {
    var _this = this;
    this.loading = (0, _utils.load)();
    this.$dictionary.get(['EB_SYS_ACCOUNT_TYPE'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.accountTypeList = res.EB_SYS_ACCOUNT_TYPE;
    }).finally(function () {
      _this.loading.close();
    });
  },
  mounted: function mounted() {
    var _this2 = this;
    this.searchFormData();
    this.$nextTick(function () {
      _this2.resizeHotTable();
    });
  },
  computed: {
    language: function language() {
      return this.$store.getters.language;
    }
  },
  methods: {
    handleDelChildrenPort: function handleDelChildrenPort(row) {
      var _this3 = this;
      var data = this.$refs.hotTableCostChildren.getSelected();
      this.$confirm(this.$t('userCenter.billConsigneeApplication.deleteConfirm'), '提示', {
        confirmButtonText: this.$t('userCenter.billConsigneeApplication.confirmButton'),
        cancelButtonText: this.$t('userCenter.billConsigneeApplication.cancelButton'),
        type: 'warning'
      }).then(function () {
        _this3.loading = (0, _utils.load)();
        var params = {
          accountNo: _this3.selectTableMainData.accountNo,
          roleCode: data.roleCode,
          portCode: data.portCode || ''
        };
        (0, _childrenUserManage.deleteSubAccountRolePort)(params).then(function (response) {
          if (response.success) {
            _this3.getTableChildrenData();
            _this3.$message({
              message: _this3.$t('userCenter.billConsigneeApplication.deleteMessage'),
              type: 'success'
            });
            _this3.selectionIds = [];
            _this3.listQuery.currentPage = 1;
            _this3.searchFormData();
          } else {
            _this3.$message({
              message: response.errorMessages[0],
              type: 'error'
            });
          }
        }).catch(function (err) {
          _this3.dialogVisible = false;
        }).finally(function () {
          _this3.loading.close();
        });
      });
    },
    searchFn: function searchFn(val) {
      this.listQueryChildren.currentPage = val.page;
      this.listQueryChildren.pageSize = val.limit;
      this.getTableChildrenData();
    },
    getTableChildrenData: function getTableChildrenData() {
      var _this4 = this;
      var params = {
        currentPage: this.listQueryChildren.currentPage,
        pageSize: this.listQueryChildren.pageSize,
        sysAccountId: this.selectTableMainData.sysAccountId
      };
      this.loading = (0, _utils.load)();
      (0, _childrenUserManage.getQueryRoleByAccountId)(params).then(function (res) {
        _this4.tableDataChildren = res.data.records;
        _this4.listQueryChildren.total = res.data.totalRecord;
      }).catch(function (err) {}).finally(function () {
        _this4.loading.close();
      });
    },
    tableMainClick: function tableMainClick(row) {
      var _this5 = this;
      this.selectTableMainData = row.record;
      this.loading = (0, _utils.load)();
      var params = {
        currentPage: this.listQueryChildren.currentPage,
        pageSize: this.listQueryChildren.pageSize,
        sysAccountId: row.record.sysAccountId
      };
      (0, _childrenUserManage.getQueryRoleByAccountId)(params).then(function (res) {
        _this5.tableDataChildren = res.data.records;
        _this5.listQueryChildren.total = res.data.totalRecord;
      }).catch(function (err) {}).finally(function () {
        _this5.loading.close();
      });
    },
    handleLock: function handleLock(row) {
      var _this6 = this;
      var data = this.$refs.hotTableCostMain.getSelected();
      if (data.lockFlag == 0) {
        var params = {
          id: data.sysAccountId,
          status: 1
        };
        this.loading = (0, _utils.load)();
        (0, _childrenUserManage.getLockSubAccount)(params).then(function (res) {
          if (res.success) {
            _this6.searchFormData();
            _this6.$message({
              message: _this6.$t('userCenter.billConsigneeApplication.lockSuccess'),
              type: 'success'
            });
          } else {
            _this6.$message({
              message: res.errorMessages[0],
              type: 'error'
            });
          }
        }).catch(function (err) {
          _this6.$message({
            message: err.errorMessages[0],
            type: 'error'
          });
        }).finally(function () {
          _this6.loading.close();
        });
      } else {
        var _params = {
          id: data.sysAccountId,
          status: 0
        };
        this.loading = (0, _utils.load)();
        (0, _childrenUserManage.getLockSubAccount)(_params).then(function (res) {
          if (res.success) {
            _this6.searchFormData();
            _this6.$message({
              message: _this6.$t('userCenter.billConsigneeApplication.unLockSuccess'),
              type: 'success'
            });
          } else {
            _this6.$message({
              message: res.errorMessages[0],
              type: 'error'
            });
          }
        }).catch(function (err) {
          _this6.$message({
            message: err.errorMessages[0],
            type: 'error'
          });
        }).finally(function () {
          _this6.loading.close();
        });
      }
    },
    handleResetPassword: function handleResetPassword(row) {
      var _this7 = this;
      var data = this.$refs.hotTableCostMain.getSelected();
      this.loading = (0, _utils.load)();
      (0, _childrenUserManage.resetDefaultPassword)(data.sysAccountId).then(function (res) {
        if (res.success) {
          _this7.$message.success(res.data);
        }
      }).catch(function (err) {
        _this7.$message({
          message: err.errorMessages[0],
          type: 'error'
        });
      }).finally(function () {
        _this7.loading.close();
      });
    },
    addUserChildren: function () {
      var _addUserChildren = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var validateAdd;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return (0, _childrenUserManage.validateAddSubAccount)();
            case 2:
              validateAdd = _context.sent;
              if (validateAdd.success) {
                _context.next = 6;
                break;
              }
              this.$message({
                message: validateAdd.errorMessages[0],
                type: 'error'
              });
              return _context.abrupt("return");
            case 6:
              if (!(this.tableDataMain.length >= 10)) {
                _context.next = 9;
                break;
              }
              this.$message({
                message: this.$t('userCenter.childrenUserManage.isAddFive'),
                type: 'warning'
              });
              return _context.abrupt("return");
            case 9:
              if (!(this.userInfo.isSubAccount == 'Y')) {
                _context.next = 12;
                break;
              }
              this.$message({
                message: this.$t('userCenter.childrenUserManage.isNotChildren'),
                type: 'warning'
              });
              return _context.abrupt("return");
            case 12:
              this.addUserDialog = true;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function addUserChildren() {
        return _addUserChildren.apply(this, arguments);
      }
      return addUserChildren;
    }(),
    setInitDialogAddUserVisible: function setInitDialogAddUserVisible(val) {
      this.addUserDialog = val;
    },
    setInitDialogAssigningRoleVisible: function setInitDialogAssigningRoleVisible(val) {
      this.addPortDialog = val;
    },
    searchFormData: function searchFormData() {
      var _this8 = this;
      var data = this.searchForm;
      data.currentPage = this.listQuery.currentPage;
      data.pageSize = this.listQuery.pageSize;
      this.loading = (0, _utils.load)();
      (0, _childrenUserManage.getQueryEbSysAccountSub)(data).then(function (res) {
        _this8.tableDataMain = res.data;
      }).catch(function (err) {}).finally(function () {
        _this8.loading.close();
      });
    },
    addPortTableData: function addPortTableData() {
      if (this.selectTableMainData.length <= 0) {
        this.$message({
          message: this.$t('userCenter.childrenUserManage.selectWarning'),
          type: 'info'
        });
        return;
      }
      this.sysAccountId = this.selectTableMainData.sysAccountId;
      this.accountNo = this.selectTableMainData.accountNo;
      this.addPortDialog = true;
    },
    resizeHotTable: function resizeHotTable() {
      this.$refs.hotTableCostMain.resizeTo();
      this.$refs.hotTableCostChildren.resizeTo();
    }
  }
};